import React, { Component } from 'react'
import ResourceItem from '../../models/resourceItem'
interface iProps {
    extraProps: ResourceItem[]
}

export default class clazzDocument extends Component<iProps> {
    render() {
        let {extraProps} = this.props
        return (
            <div className="clazzDocument">
                {!!(extraProps && extraProps.length) &&
                <iframe 
                    style={{width:'100%', height:'100%', overflow:'visible'}}
                    ref="iframe" 
                    src={`https://bsjy.dbxiao.com/pdfjs/web/viewer.html?file=${encodeURIComponent(extraProps[0]?.playUrl)}`}
                    width="100%" 
                    scrolling="no" 
                    frameBorder="0"
                />}
            </div>
        )
    }
}
